/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExternalEhrType } from './ExternalEhrType';
import {
    ExternalEhrTypeFromJSON,
    ExternalEhrTypeFromJSONTyped,
    ExternalEhrTypeToJSON,
} from './ExternalEhrType';

/**
 * 
 * @export
 * @interface ExternalEhrFacility
 */
export interface ExternalEhrFacility {
    /**
     * 
     * @type {string}
     * @memberof ExternalEhrFacility
     */
    facility_id?: string;
    /**
     * 
     * @type {ExternalEhrType}
     * @memberof ExternalEhrFacility
     */
    type?: ExternalEhrType;
    /**
     * 
     * @type {string}
     * @memberof ExternalEhrFacility
     */
    external_organization_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalEhrFacility
     */
    external_facility_id?: string;
}

/**
 * Check if a given object implements the ExternalEhrFacility interface.
 */
export function instanceOfExternalEhrFacility(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExternalEhrFacilityFromJSON(json: any): ExternalEhrFacility {
    return ExternalEhrFacilityFromJSONTyped(json, false);
}

export function ExternalEhrFacilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEhrFacility {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facility_id': !exists(json, 'facility_id') ? undefined : json['facility_id'],
        'type': !exists(json, 'type') ? undefined : ExternalEhrTypeFromJSON(json['type']),
        'external_organization_id': !exists(json, 'external_organization_id') ? undefined : json['external_organization_id'],
        'external_facility_id': !exists(json, 'external_facility_id') ? undefined : json['external_facility_id'],
    };
}

export function ExternalEhrFacilityToJSON(value?: ExternalEhrFacility | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facility_id': value.facility_id,
        'type': ExternalEhrTypeToJSON(value.type),
        'external_organization_id': value.external_organization_id,
        'external_facility_id': value.external_facility_id,
    };
}

